export default {
    GOOGLE: {
        GA_TRACKING_CODE: 'G-XWKV8DEWP7'
    }
}